<kodit-dropdown
  [formCtrlId]="formCtrlId"
  [options]="items"
  ctrlTooltip="Izaberite prikaz radnog naloga"
  ctrlTooltipPosition="top"
  [formCtrl]="formCtrl"
></kodit-dropdown>
